module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modallogin",
    attrs: {
      "id": "modallogin",
      "hide-footer": true,
      "title": "Identification"
    }
  }, [_c('div', {
    staticClass: "row text-left"
  }, [(!_vm.user) ? _c('div', {
    staticClass: "col"
  }, [_c('h6', {
    staticClass: "card-title text-left"
  }, [_vm._v("Merci de vous authentifier pour lancer ce mode de jeu")]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "id": "emailForm",
      "label": "Email :",
      "label-cols-xl": "4",
      "label-cols-lg": "3",
      "label-for": "email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "john.doe@gmail.com"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', [_vm._v("\n          On y est presque..."), _c('br'), _vm._v("Pouvez-vous me donner un petit nom d'au moins 2 caractères ?\n        ")])], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "id": "passwordForm",
      "label": "Mot de passe :",
      "label-cols-xl": "4",
      "label-cols-lg": "3",
      "label-for": "password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "***********"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), (_vm.signup) ? _c('span', [_c('b-form-group', {
    attrs: {
      "id": "passwordconfirmationForm",
      "label": "Confirmez votre mot de passe :",
      "label-cols-xl": "4",
      "label-cols-lg": "3",
      "label-for": "passwordconfirmation"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "passwordconfirmation",
      "type": "password",
      "placeholder": "***********"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "id": "playerNameForm",
      "label": "Nom ou pseudo :",
      "label-cols-xl": "4",
      "label-cols-lg": "3",
      "label-for": "get_player_name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "get_player_name",
      "type": "text",
      "maxlength": "30",
      "placeholder": "John Doe",
      "state": _vm.playerNameValid
    },
    model: {
      value: (_vm.playerNameForm),
      callback: function($$v) {
        _vm.playerNameForm = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "playerNameForm"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', [_vm._v("\n            On y est presque..."), _c('br'), _vm._v("Pouvez-vous me donner un petit nom d'au moins 2 caractères ?\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(!_vm.signup) ? _c('span', [_c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function($event) {
        _vm.signup = !_vm.signup
      }
    }
  }, [_vm._v("Créer mon compte")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("S'identifier")])], 1) : _c('span', [_c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function($event) {
        _vm.signup = !_vm.signup
      }
    }
  }, [_vm._v("S'identifier")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.signUp()
      }
    }
  }, [_vm._v("Créer mon compte")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n          ou connectez-vous avec votre compte Google"), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "social-button",
    on: {
      "click": _vm.socialLogin
    }
  }, [_c('img', {
    attrs: {
      "alt": "google logo",
      "src": require('@/assets/images/google-logo.png')
    }
  })])])])], 1) : _c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n        Votre email : " + _vm._s(_vm.user.email)), _c('br'), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Se déconnecter")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14a5e870","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-login.vue
// module id = 3H7d
// module chunks = 1